import { IsUUID } from 'class-validator';
import { CreateLobbyDto } from '.';

export class UpdateLobbyDto extends CreateLobbyDto {
	@IsUUID()
	id: string;
}
